var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"showHeader":_vm.isMobile},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('ModalHeader',{staticClass:"demo-walkthrough-header"})]},proxy:true},{key:"body",fn:function(ref){
var bodyClass = ref.bodyClass;
return [_c(_vm.pages[_vm.currentPageIndex],{tag:"component",class:bodyClass})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }